import { useEffect } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';
import user from 'js/lib/user';

import SessionStore from 'bundles/course-sessions/stores/SessionStore';
import { loadCourseDeadlines } from 'bundles/in-course-stores/actions/CourseDeadlineActions';
import CourseMembershipStore from 'bundles/in-course-stores/stores/CourseMembershipStore';
import CourseScheduleStore from 'bundles/in-course-stores/stores/CourseScheduleStore';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';
import ProgressStore from 'bundles/in-course-stores/stores/ProgressStore';

export const useLoadCourseDeadlines = () => {
  const { courseId } = useFluxibleStore(CourseStore, (store) => ({ courseId: store.getCourseId() }));

  const { loading: sessionLoading } = useFluxibleStore(SessionStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: courseScheduleLoading } = useFluxibleStore(CourseScheduleStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: courseMembershipLoading } = useFluxibleStore(CourseMembershipStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: progressLoading } = useFluxibleStore(ProgressStore, (store) => ({
    loading: !store.hasLoaded(),
  }));
  const { loading: courseLoading } = useFluxibleStore(CourseStore, (store) => ({
    loading: !store.hasLoaded(),
  }));

  const executeAction = useFluxibleAction();

  const loading =
    sessionLoading || courseScheduleLoading || courseMembershipLoading || progressLoading || courseLoading;

  useEffect(() => {
    if (courseId && !loading) {
      const userId = user.get().id.toString();
      executeAction(loadCourseDeadlines, { userId });
    }
  }, [courseId, loading, executeAction]);
};
